export enum SubcontractorHolidayPaymentRouteType {
  Regular = "academicYears",
  Cca = "ccaAcademicYears",
}

export const subcontractorHolidayPaymentRouteTypeList = [
  { id: SubcontractorHolidayPaymentRouteType.Regular, name: "Regular" },
  { id: SubcontractorHolidayPaymentRouteType.Cca, name: "CCA" },
];

export enum SubcontractorHolidayPaymentPricingType {
  FullPayment = "full_payment",
  HalfPayment = "half_payment",
  QuarterPayment = "quarter_payment",
}

export const subcontractorHolidayPaymentPricingTypeList = [
  {
    id: SubcontractorHolidayPaymentPricingType.FullPayment,
    name: "Full Payment",
  },
  {
    id: SubcontractorHolidayPaymentPricingType.HalfPayment,
    name: "Half Payment",
  },
  {
    id: SubcontractorHolidayPaymentPricingType.QuarterPayment,
    name: "Quarter Payment",
  },
];

export const subcontractorHolidayPaymentMonthList = [
  { id: 1, name: "January" },
  { id: 2, name: "February" },
  { id: 3, name: "March" },
  { id: 4, name: "April" },
  { id: 5, name: "May" },
  { id: 6, name: "June" },
  { id: 7, name: "July" },
  { id: 8, name: "August" },
  { id: 9, name: "September" },
  { id: 10, name: "October" },
  { id: 11, name: "November" },
  { id: 12, name: "December" },
];
